export default "__VITE_ASSET__dEvIE8t7__"